/* ca-view-as.js — "View as" grid/list switch for Collection + Search.
   Writes a data attribute on <html> (never inside #ProductGridContainer, which
   facets.js replaces on every filter change) and remembers the choice per
   template. Purely presentational: no cart, quote or pre-order logic touched. */
(function () {
  var ATTR = 'data-ca-view';

  function key() {
    return document.body.classList.contains('template-search') ? 'ca-view-as-search' : 'ca-view-as-collection';
  }

  function apply(view) {
    document.documentElement.setAttribute(ATTR, view);
    document.querySelectorAll('.ca-viewas__btn').forEach(function (btn) {
      var on = btn.getAttribute('data-view') === view;
      btn.classList.toggle('is-active', on);
      btn.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
  }

  function init() {
    var bar = document.querySelector('.ca-viewas');
    if (!bar) return;
    var stored = null;
    try { stored = localStorage.getItem(key()); } catch (e) {}
    apply(stored === 'list' || stored === 'grid' ? stored : (bar.getAttribute('data-default-view') || 'grid'));
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('.ca-viewas__btn');
    if (!btn) return;
    e.preventDefault();
    var view = btn.getAttribute('data-view');
    apply(view);
    try { localStorage.setItem(key(), view); } catch (err) {}
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  // Facet AJAX swaps the toolbar markup back in — re-sync the button state.
  document.addEventListener('shopify:section:load', init);
  new MutationObserver(function () {
    var view = document.documentElement.getAttribute(ATTR);
    if (view) {
      document.querySelectorAll('.ca-viewas__btn').forEach(function (btn) {
        btn.classList.toggle('is-active', btn.getAttribute('data-view') === view);
      });
    }
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
